
// Denna modul är "reusable" och används av apparna för Kundfaktura och Leverantörsfaktura:

const modul = {
	namespaced: true,

	// Denna är en function för att denna modul ska kunna vara "reusable" och används av flera appar/sidor::
	state () {
		return {

			radtexterVisas: true,	// = initialt defaultvärde

			rullningsbaraElement: [ 	// = initiala defaultvärden
				{ id:'re1', scrollTop: 0 }
			]
		};
	},

	mutations: {

		setRadtexterVisas(state, nyttVarde)
		{
			// `state` is the local module state
			state.radtexterVisas = nyttVarde;
		}

		// rullningsbaraElement muteras via en "root mutation" som används av flera modules/namespaces:
	}

	//actions: { ... },

	//getters: { ... }
};

export { modul as ssoStatestoreFaktura };
